var _ellipse, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Speedometer50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 19,
    ry: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 31,
    r: 23,
    fill: "orange"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,8C19.297,8,9,18.297,9,31c0,0.578,0.029,1.148,0.07,1.715 c0.055,0.002,0.112,0.012,0.167,0.012c2.449,0,4.588-1.8,4.944-4.295C15.435,19.634,23.095,13,32,13 c1.508,0,3.003,0.186,4.444,0.552c2.496,0.633,5.006-0.744,5.889-3.098C39.226,8.887,35.717,8,32,8z",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 31,
    r: 18,
    fill: "#68e5fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd3c4f",
    d: "M37.516,28.592c-0.726-0.267-1.533,0.063-1.868,0.757l-6.5,13.5 c-0.224,0.465-0.193,1.012,0.082,1.449C29.504,44.735,29.984,45,30.5,45h3c0.684,0,1.28-0.462,1.452-1.124l3.5-13.5 C38.646,29.629,38.241,28.857,37.516,28.592z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a8172d",
    d: "M48.5,32h-3c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h3c0.829,0,1.5,0.671,1.5,1.5 S49.329,32,48.5,32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M18.5,32h-3c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h3c0.829,0,1.5,0.671,1.5,1.5 S19.329,32,18.5,32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a8172d",
    d: "M44.667,43.667c-0.384,0-0.768-0.146-1.061-0.439l-2.122-2.122c-0.586-0.585-0.586-1.536,0-2.121 c0.586-0.586,1.535-0.586,2.121,0l2.122,2.122c0.586,0.585,0.586,1.536,0,2.121C45.435,43.521,45.051,43.667,44.667,43.667z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M19.333,43.667c-0.384,0-0.768-0.146-1.061-0.439c-0.586-0.585-0.586-1.536,0-2.121l2.122-2.122 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.585,0.586,1.536,0,2.121l-2.122,2.122C20.1,43.521,19.716,43.667,19.333,43.667z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M22.454,22.454c-0.384,0-0.768-0.146-1.061-0.439l-2.122-2.122c-0.586-0.585-0.586-1.536,0-2.121 c0.586-0.586,1.535-0.586,2.121,0l2.122,2.122c0.586,0.585,0.586,1.536,0,2.121C23.222,22.308,22.838,22.454,22.454,22.454z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a8172d",
    d: "M41.546,22.454c-0.384,0-0.768-0.146-1.061-0.439c-0.586-0.585-0.586-1.536,0-2.121l2.122-2.122 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.585,0.586,1.536,0,2.121l-2.122,2.122C42.313,22.308,41.93,22.454,41.546,22.454z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M32,18.5c-0.829,0-1.5-0.671-1.5-1.5v-3c0-0.829,0.671-1.5,1.5-1.5s1.5,0.671,1.5,1.5v3 C33.5,17.829,32.829,18.5,32,18.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#008aa9",
    d: "M32,54c4.25,0,8.23-1.153,11.646-3.163c1.189-0.699,1.369-2.335,0.342-3.255 C40.806,44.734,36.607,43,32,43s-8.806,1.734-11.988,4.582c-1.028,0.92-0.847,2.556,0.342,3.255C23.77,52.847,27.75,54,32,54z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55,31c0-2.518-0.41-4.938-1.158-7.206c-2.461,0.525-4.193,2.806-3.934,5.367 C49.969,29.769,50,30.388,50,31c0,8.924-6.386,16.402-15.184,17.781c-2.546,0.399-4.314,2.657-4.195,5.174 C31.078,53.982,31.537,54,32,54C44.703,54,55,43.703,55,31z",
    opacity: 0.15
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.666,20.633c-0.317,0-0.638-0.1-0.909-0.308c-0.659-0.503-0.785-1.444-0.282-2.103 c2.504-3.28,6.05-5.735,9.985-6.912c0.794-0.24,1.629,0.213,1.867,1.007c0.237,0.793-0.213,1.629-1.007,1.867 c-3.332,0.997-6.336,3.077-8.459,5.858C17.564,20.43,17.118,20.633,16.666,20.633z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Speedometer50);
export default __webpack_public_path__ + "static/media/icons8-speedometer-50.899dbd2855dfb1fa4a48ae4261d58b58.svg";
export { ForwardRef as ReactComponent };